const Layout = {
  P: 20,
  S: 20,
  R: 12,
  desktopHeaderHeight: 100,
};

export default Layout;
